import React, { useState } from "react";

const blogPosts = [
  {
    title: "Wheelchairs 101: Choosing the Right Model for Mobility",
    description:
      "Augue ut lectus arcu bibendum at varius vel. Ipsum nunc aliquet bibendum enim facilisis. Quam...",
    image:
      "https://qx-medin.myshopify.com/cdn/shop/articles/blog-1.png?v=1745770907&width=720",
    author: "Qodex Web",
    date: "April 14 2025",
  },
  {
    title: "Digital Thermometers vs. Infrared Thermometers: What’s Better?",
    description:
      "Augue ut lectus arcu bibendum at varius vel. Ipsum nunc aliquet bibendum enim facilisis. Quam...",
    image:
      "https://qx-medin.myshopify.com/cdn/shop/articles/blog-6.png?v=1744633432&width=720",
    author: "Qodex Web",
    date: "April 14 2025",
  },
  {
    title: "Glucometers Explained: Managing Diabetes Effectively",
    description:
      "Augue ut lectus arcu bibendum at varius vel. Ipsum nunc aliquet bibendum enim facilisis. Quam...",
    image:
      "https://qx-medin.myshopify.com/cdn/shop/articles/blog-2.png?v=1744633447&width=720",
    author: "Qodex Web",
    date: "April 14 2025",
  },
  {
    title: "First Aid Tips Everyone Should Know",
    description:
      "Learn basic first aid steps you can take to help someone in need before emergency responders arrive.",
    image:
      "https://qx-medin.myshopify.com/cdn/shop/articles/blog-5.png?v=1744633508&width=720",
    author: "Qodex Web",
    date: "April 14 2025",
  },
  {
    title: "Healthy Eating for Diabetics",
    description:
      "Understanding what to eat and what to avoid can help manage diabetes and maintain energy levels.",
    image:
      "https://qx-medin.myshopify.com/cdn/shop/articles/blog-4.png?v=1744633500&width=720",
    author: "Qodex Web",
    date: "April 14 2025",
  },
];

function BlogSlider() {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 3;

  const nextSlide = () => {
    if (startIndex + visibleCount < blogPosts.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prevSlide = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  return (
    <div style={{ padding: "60px 20px", fontFamily: "'Segoe UI', sans-serif", maxWidth: "100%", margin: "auto" }}>
      <div style={{ color: "#3A8DF5", fontWeight:"bold", textAlign: "center", letterSpacing: "2px", fontSize: "14px", marginBottom: "10px" }}>
        LATEST NEWS
      </div>
      <h2 style={{ fontSize: "42px", fontWeight: "700", textAlign: "center", marginBottom: "50px", color: "#111" }}>
        From our Blog
      </h2>

      <div style={{ position: "relative" }}>
        <div
          style={{
            display: "flex",
            gap: "24px",
            overflow: "hidden",
            justifyContent: "center",
            transition: "transform 0.5s ease",
          }}
        >
          {blogPosts.slice(startIndex, startIndex + visibleCount).map((post, index) => (
            <div
              key={index}
              style={{
                width: "435px",
                borderRadius: "5px",
                // boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                overflow: "hidden",
                // backgroundColor: "#fff",
                // border: "1px solid #f0f0f0",
                flexShrink: 0,
              }}
            >
              <img
                src={post.image}
                alt={post.title}
                style={{ width: "100%", height: "291px", objectFit: "cover" }}
              />
              <div style={{ padding: "22px 0px", background:"none" }}>
                <div style={{ fontSize: "14px", color: "#888", marginBottom: "10px" }}>
                  By <strong>{post.author}</strong> &nbsp; {post.date}
                </div>
                <div style={{ fontSize: "20px", fontWeight: "700", color: "#111", marginBottom: "14px" }}>
                  {post.title}
                </div>
                <div style={{ fontSize: "15px", color: "#777", lineHeight: "1.6", marginBottom: "18px" }}>
                  {post.description}
                </div>
                {/* <button
                  style={{
                    backgroundColor: "#00b5f1",
                    padding: "10px 20px",
                    border: "none",
                    color: "#fff",
                    fontWeight: "600",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  READ MORE
                </button> */}
              </div>
            </div>
          ))}
        </div>

  
        {/* <button
          onClick={prevSlide}
          style={{
            position: "absolute",
            left: "-20px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "#ddd",
            border: "none",
            padding: "10px",
            cursor: "pointer",
            borderRadius: "50%",
            fontWeight: "bold",
          }}
        >
          ‹
        </button> */}
        {/* <button
          onClick={nextSlide}
          style={{
            position: "absolute",
            right: "-20px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "#ddd",
            border: "none",
            padding: "10px",
            cursor: "pointer",
            borderRadius: "50%",
            fontWeight: "bold",
          }}
        >
          ›
        </button> */}
      </div>

      {/* Pagination Dots */}
      <div style={{ textAlign: "center", marginTop: "30px" }}>
        {Array.from({ length: blogPosts.length - visibleCount + 1 }).map((_, idx) => (
          <span
            key={idx}
            onClick={() => setStartIndex(idx)}
            style={{
              display: "inline-block",
              width: "8px",
              height: "8px",
              margin: "0 4px",
              backgroundColor: startIndex === idx ? "#1a237e" : "#ccc",
              borderRadius: "50%",
              cursor: "pointer",
            }}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default BlogSlider;
